import { useId } from "react";
import { useTranslation } from "react-i18next";
import { MenuItem, TextField } from "@mui/material";

// Wert „Alle Regionen“ im Select; nach außen ist er null.
const ALL = "";

/** Region als reiner Filter des Boards, nur im Mehrzielmodus (Vertrag V.3). Steht neben dem Topic Filter. */
export default function RegionFilter({ regions = [], value = null, onChange }) {
  const { t } = useTranslation("freigabe");
  const id = useId();
  return <TextField select size="small" id={id} label={t("stageBranches.regionFilter.label")} value={value ?? ALL}
    SelectProps={{ displayEmpty: true, MenuProps: { PaperProps: { className: "iio iio-monitor-menu" } } }}
    InputLabelProps={{ shrink: true }} sx={{ minWidth: 160, maxWidth: "100%" }}
    onChange={event => onChange?.(event.target.value === ALL ? null : event.target.value)}>
    <MenuItem value={ALL}>{t("stageBranches.regionFilter.all")}</MenuItem>
    {regions.map(region => <MenuItem key={region} value={region}>{region}</MenuItem>)}
  </TextField>;
}
